import React, { useEffect, useState } from "react";
import { Card, Row, Col, ProgressBar, Container } from "react-bootstrap";
import { getPrestacionesCountByEmpresaMonth } from "../../services/firebase/prestaciones/index";
import { getMovimientosCountByEmpresaMonth } from "../../services/firebase/movimientos/index";
import { getPacientesCountByEmpresa } from "../../services/firebase/pacientes/index";
import { useSelector } from "react-redux";

const metas = {
  pacientes: 100,
  movimientos: 200,
  prestaciones: 150,
};

export default function DashboardMetas() {
  const empresa = useSelector((state) => state.empresa);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ pacientes: 0, movimientos: 0, prestaciones: 0 });

  useEffect(() => {
    async function fetchStats() {
      setLoading(true);
      const currentDate = new Date();
      const empresaId = empresa.id;
      const [pacientes, movimientos, prestaciones] = await Promise.all([
        getPacientesCountByEmpresa(empresaId),
        getMovimientosCountByEmpresaMonth(currentDate, empresaId),
        getPrestacionesCountByEmpresaMonth(currentDate, empresaId),
      ]);
      setStats({ pacientes, movimientos, prestaciones });
      setLoading(false);
    }
    if (empresa && empresa.id) fetchStats();
  }, [empresa]);

  const renderCard = (label, value, meta) => {
    const percent = Math.min(100, Math.round((value / meta) * 100));
    return (
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Card.Title className="fw-bold text-primary mb-2">{label}</Card.Title>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span>Meta: <strong>{meta}</strong></span>
            <span>Actual: <strong>{value}</strong></span>
          </div>
          <ProgressBar now={percent} label={`${percent}%`} variant={percent >= 100 ? "success" : "info"} />
        </Card.Body>
      </Card>
    );
  };

  return (
    <Container className="py-5">
      <h2 className="text-center fw-bold mb-4" style={{ color: '#0d6efd' }}>Metas del Mes</h2>
      {loading ? (
        <div className="text-center py-5">Cargando...</div>
      ) : (
        <Row className="justify-content-center">
          <Col xs={12} md={6} lg={4}>{renderCard("Pacientes", stats.pacientes, metas.pacientes)}</Col>
          <Col xs={12} md={6} lg={4}>{renderCard("Movimientos", stats.movimientos, metas.movimientos)}</Col>
          <Col xs={12} md={6} lg={4}>{renderCard("Prestaciones", stats.prestaciones, metas.prestaciones)}</Col>
        </Row>
      )}
    </Container>
  );
}
